export const messages = {
  en: {
    workPool: {
      search: {
        title: 'Search Conditions',
        workName: 'Work Order Name',
        createUser: 'Creator',
        staffName: 'Processor',
        startTime: 'Start Time',
        endTime: 'End Time'
      },
      list: {
        title: 'Work Order Pool'
      },
      table: {
        id: 'ID',
        workName: 'Work Name',
        typeName: 'Type Name',
        workCycle: 'Cycle Type',
        once: 'One-time',
        cycle: 'Periodic',
        createUser: 'Creator',
        staffName: 'Processor',
        timeRange: 'Time Range',
        status: 'Status',
        createTime: 'Create Time',
        finishTime: 'Finish Time',
        timeout: 'Timeout'
      },
      state: {
        all: 'All',
        pending: 'Pending',
        completed: 'Completed',
        timeout: 'Timeout Work Orders'
      },
      fetchError: 'Failed to fetch work orders'
    }
  },
  zh: {
    workPool: {
      search: {
        title: '查询条件',
        workName: '请输入工单名称',
        createUser: '请输入发起人',
        staffName: '请输入处理人',
        startTime: '请输入开始时间',
        endTime: '请输入结束时间'
      },
      list: {
        title: '工作单池'
      },
      table: {
        id: '编号',
        workName: '工单名称',
        typeName: '类型名称',
        workCycle: '标识',
        once: '一次性工单',
        cycle: '周期性工单',
        createUser: '发起人',
        staffName: '处理人',
        timeRange: '时间段',
        status: '状态',
        createTime: '创建时间',
        finishTime: '完成时间',
        timeout: '超时'
      },
      state: {
        all: '全部',
        pending: '待处理',
        completed: '处理完成',
        timeout: '超时工作单'
      },
fetchError: '获取工作单列表失败'
    }
  },
  'zh-TW': {
    workPool: {
      search: {
        title: '查詢條件',
        workName: '請輸入工單名稱',
        createUser: '請輸入發起人',
        staffName: '請輸入處理人',
        startTime: '請輸入開始時間',
        endTime: '請輸入結束時間'
      },
      list: {
        title: '工作單池'
      },
      table: {
        id: '編號',
        workName: '工單名稱',
        typeName: '類型名稱',
        workCycle: '標識',
        once: '一次性工單',
        cycle: '周期性工單',
        createUser: '發起人',
        staffName: '處理人',
        timeRange: '時間段',
        status: '狀態',
        createTime: '創建時間',
        finishTime: '完成時間',
        timeout: '超時'
      },
      state: {
        all: '全部',
        pending: '待處理',
        completed: '處理完成',
        timeout: '超時工作單'
      },
      fetchError: '獲取工作單列表失敗'
    }
  }
}